<template lang="pug">
div
  nuxt-link.news-card-link.d-block(:to='localePath(article.path)')
    .news-card-media
      base-img.news-card-media__image(
        :height='prominent ? 640 : 450'
        :src='articleImage'
        :alt='article.title'
        :sizes='prominent ? "xs:100vw sm:100vw md:900px lg:1076px xl:1280px" : "xs:100vw sm:100vw md:538px lg:640px xl:900px"'
        flat
        tile
        cover
      )

      .news-card-overlay(
        v-if="showOverlay"
        aria-hidden="true"
      )
        .news-card-overlay__content
          h1.news-card-overlay-title {{ article.title }}
              
      //- v-row.ma-0.fill-height(align='end', justify='end')
        //- v-sheet.pa-2.d-inline-flex.align-center.justify-center(
          color='primary',
          dark,
          tile,
          height='40',
          width='40'
        )
          //- v-con(v-if='icon', v-text='icon')
  v-theme-provider(:theme='isDark? "light" : "dark"')
    v-sheet.d-flex(
      tile,
      max-width='100%'
    )
      .grow.pa-2.body-2
        .d-flex.align-center.fill-height
          span.px-2(v-text='formattedDate')
          //- span.px-2(v-text='category')
          //- template(v-if='$vuetify.breakpoint.mdAndUp')
            span.px-2(v-text='`${comments} Comments`')
  #article-text.pa-4(v-if='showText')
    base-title.text-truncate.text-uppercase(:title='title')
    p(v-if='truncate') {{ article.description }}
    content-renderer.content-renderer(v-else, :value='article')
  v-btn.font-weight-bold(v-if='readMore', text) {{ t('pages.articles.readMore') }}
  v-divider.mt-6(v-if='divider')
</template>

<script setup>
import { publicAssetPath } from '~/utils/assets'

defineOptions({
  name: 'NewsCard',
})

const props = defineProps({
  category: { type: String, default: '' },
  // comments: { type: [Number, String], default: null },
  date: { type: String, default: '' },
  divider: Boolean,
  // icon: { type: String, default: '' },
  prominent: Boolean,
  readMore: Boolean,
  image: { type: String },
  title: { type: String, default: '' },
  truncate: { type: Boolean },
  description: { type: String, default: '' },
  article: { type: Object, required: true, default: () => ({}) },
  showText: { type: Boolean, default: true },
  showOverlay: { type: Boolean, default: false },
})

const isDark = false
const { locale, t } = useI18n()
const localePath = useLocalePath()
const dateFormatter = computed(
  () =>
    new Intl.DateTimeFormat(locale.value === 'de' ? 'de-DE' : 'en-US', {
      month: 'long',
      day: 'numeric',
      year: 'numeric',
      timeZone: 'UTC',
    }),
)

const formattedDate = computed(() => {
  if (!props.date) {
    return ''
  }

  const normalizedDate =
    props.date.length <= 10 ? `${props.date}T00:00:00Z` : props.date

  return dateFormatter.value.format(new Date(normalizedDate))
})

const articleImage = computed(() => publicAssetPath(props.article.image))
</script>

<style scoped>
.news-card-link {
  display: block;
}

.news-card-media {
  position: relative;
  overflow: hidden;
}

.news-card-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: flex-end;
  background: linear-gradient(
    180deg,
    rgba(16, 26, 34, 0.18) 0%,
    rgba(16, 26, 34, 0.72) 100%
  );
  padding: clamp(1rem, 2vw, 2rem);
}

.news-card-overlay__content {
  max-width: min(80%, 48rem);
}

.news-card-overlay-title {
  margin: 0;
  color: white;
  font-size: clamp(1.7rem, 2.7vw, 2.35rem);
  font-weight: 800;
  line-height: 1.08;
  text-wrap: balance;
  text-shadow: 0 3px 18px rgba(0, 0, 0, 0.45);
}
</style>
